export const HEADING = "Next, let's choose a benefit period";

export const BENEFIT_PERIOD_DIAGRAM_URL =
  'https://policygenius.com/assets/disability/benefit-period.svg';
export const BENEFIT_PERIOD_DIAGRAM_ALT =
  'The benefit period is the length of time the benefit amount will be paid out (each month).';
